import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada including a new error key for mandatory field validation
const translations = {
  en: {
    header: "Mode of Approach/Communication",
    mobileLabel: "Mobile:",
    linkLabel: "Link:",
    urlLabel: "URL:",
    placeholderMobile: "Enter Mobile Number",
    placeholderLink: "Enter Profile ID / URL",
    placeholderUrl: "Enter Website / URL",
    ok: "OK",
    errorSelect: "Please select an option before proceeding.",
    errorMandField: "Please fill the required field(s).",  // New error message key
    alert: "Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    header: "संचार का माध्यम",
    mobileLabel: "मोबाइल:",
    linkLabel: "लिंक:",
    urlLabel: "URL:",
    placeholderMobile: "मोबाइल नंबर दर्ज करें",
    placeholderLink: "प्रोफ़ाइल आईडी / URL दर्ज करें",
    placeholderUrl: "वेबसाइट / URL दर्ज करें",
    ok: "ठीक है",
    errorSelect: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    errorMandField: "कृपया आवश्यक फ़ील्ड भरें।",  // New error message key
    alert: "कृपया अगला प्रश्न करने से पहले वर्तमान प्रश्न का उत्तर दें।",
  },
  Kn: {
    header: "ವಂಚಕರು ನಿಮ್ಮನ್ನು ಹೇಗೆ ಸಂಪರ್ಕ ಮಾಡಿದರು ಎಂಬುದನ್ನು ಆಯ್ಕೆ ಮಾಡಿ.",
    mobileLabel: "ಮೊಬೈಲ್:",
    linkLabel: "ಲಿಂಕ್:",
    urlLabel: "URL:",
    placeholderMobile: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    placeholderLink: "ಪ್ರೊಫೈಲ್ ಐಡಿ / URL ನಮೂದಿಸಿ",
    placeholderUrl: "ವೆಬ್‌ಸೈಟ್ / URL ನಮೂದಿಸಿ",
    ok: "ಸರಿ",
    errorSelect: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಆಯ್ಕೆಮಾಡಿ.",
    errorMandField: "ದಯವಿಟ್ಟು ಅಗತ್ಯವಿರುವ ಕ್ಷೇತ್ರಗಳನ್ನು ತುಂಬಿ.",  // New error message key
    alert: "ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
  },
};

const SuspectCall = ({
  onNext,
  onSuspectCallSelected,
  onQuestion,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  onPhoneNumber,
  answer,
  selectedLang
}) => {
  const [communication, setCommunication] = useState({
    contactValues: [],
    contactIds: [],
  });
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [previousSelectedContacts, setPreviousSelectedContacts] =
    useState(null);
  const [previousSelectedPhone, setPreviousSelectedPhone] = useState([]);
  const [rawCommunicationData, setRawCommunicationData] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/suspectcall.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio14.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio14.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };

  // Update audio source when language or play state changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);


       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Load stored suspect call data and phone numbers from localStorage
  useEffect(() => {
    const storedSuspectCall = localStorage.getItem("suspectCall");
    if (storedSuspectCall) {
      const storedContacts = JSON.parse(storedSuspectCall);
      setCommunication(storedContacts);
      onSuspectCallSelected(storedContacts);
      setPreviousSelectedContacts(storedContacts);
    }

    const storedPhoneNumbers = localStorage.getItem("phoneNumbers");
    if (storedPhoneNumbers) {
      const parsedPhones = JSON.parse(storedPhoneNumbers);
      setPhoneNumbers(parsedPhones);
      setPreviousSelectedPhone(parsedPhones);
    }
  }, []);

  const getCommunicationList = (resp, language) => {
    switch (language) {
      case "en":
        return resp.lang_eng;
      case "Hi":
        return resp.lang_hin;
      case "Kn":
        return resp.lang_kanada;
      default:
        return resp.lang_eng; // fallback
    }
  };

  useEffect(() => {
    const generateId = (index) => {
      if (index < 26) {
        // For index 0-25, use uppercase letters A-Z.
        return String.fromCharCode(65 + index);
      } else if (index < 52) {
        // For index 26-51, use lowercase letters a-z.
        return String.fromCharCode(97 + index - 26);
      } else {
        // Fallback to numeric or combined identifiers if more than 52 items.
        return index.toString();
      }
    };
    if (rawCommunicationData) {
      const communicationList = getCommunicationList(rawCommunicationData, selectedLang) || [];
      setOptions(
        communicationList.map((communication, index) => ({
          // id: String.fromCharCode(65 + index),
          id: generateId(index),
          value: communication.scom_uniq,
          label: communication.scom_nm,
          mob_req: communication.mob_req, // 1 if required
          mob_show: communication.mob_show, // 1 if phone number input should be displayed
          mob_typ: communication.mob_typ, 
        })) || []
      );
    }
  }, [selectedLang, rawCommunicationData]);

  // Fetch communication options from API
  useEffect(() => {
    const fetchPlatFormData = async () => {
      try {
        const platFormResponse = await fetch(
          `${apiUrl}/v1/cy_ma_suspect_comncation_list`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f653ab73faa",
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          }
        );
        if (!platFormResponse.ok) {
          throw new Error("Failed to fetch options");
        }
        const communicationData = await platFormResponse.json();
        setRawCommunicationData(communicationData.resp);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchPlatFormData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const handleOptionClick = (option, e) => {
    e.preventDefault();
    setShowOkButton(true);
    setError("");

    setCommunication((prevContacts) => {
      let updatedContacts;
      let updatedPhoneNumbers = [...phoneNumbers];

      if (prevContacts.contactValues.includes(option.value)) {
        // If already selected, remove it
        updatedPhoneNumbers = updatedPhoneNumbers.filter(
          (phone) => phone.id !== option.value
        );
        updatedContacts = {
          contactValues: prevContacts.contactValues.filter(
            (val) => val !== option.value
          ),
          contactIds: prevContacts.contactIds.filter(
            (id) => id !== option.id
          ),
        };
      } else {
        // Else, add it along with an empty phone number entry
        updatedPhoneNumbers.push({ id: option.value, number: "" });
        updatedContacts = {
          contactValues: [...prevContacts.contactValues, option.value],
          contactIds: [...prevContacts.contactIds, option.id],
        };
      }

      setPhoneNumbers(updatedPhoneNumbers);
      localStorage.setItem("phoneNumbers", JSON.stringify(updatedPhoneNumbers));
      onSuspectCallSelected(updatedContacts);
      localStorage.setItem("suspectCall", JSON.stringify(updatedContacts));
      return updatedContacts;
    });
  };

  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }

    // Validate that all required inputs for selected options are filled
    for (const opt of options) {
      if (communication.contactValues.includes(opt.value) && opt.mob_req === 1) {
        const phone = phoneNumbers.find(p => p.id === opt.value);
        if (!phone || phone.number.trim() === "") {
          setError('errorMandField');
          // setShowOkButton(false);
          return; // Stop further processing if a required field is not filled
        }
      }
    }

    // Check if there is a change in selection
    if (
      JSON.stringify(communication) !== JSON.stringify(previousSelectedContacts) ||
      JSON.stringify(phoneNumbers) !== JSON.stringify(previousSelectedPhone)
    ) {
      if (communication.contactIds.length > 0) {
        await saveDataToAPI(communication);
        setPreviousSelectedContacts(communication);
        setPreviousSelectedPhone(phoneNumbers);
      } else {
        setError('errorSelect');
        setShowOkButton(false);
        return;
      }
    } else {
      onNext(14);
      onQuestion(15);
    }
  };

  const saveDataToAPI = async (selectedContacts) => {
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_sus_communication`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f653ab73faa",
          qtion_num: "12",
          qtion_option: selectedContacts.contactIds,
          option_val: selectedContacts.contactValues,
          lac_token: botToken,
          app_ver: app_ver,
          sus_array: phoneNumbers,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to save data");
      }

      const data = await response.json();
      if (data.resp.error_code === "0") {
        onSuspectCallSelected(communication);
        onNext(14);
        onQuestion(15);
      } else {
        setError("Failed to push data to API");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save data, please try again.");
    }
  };

  const handleInputChange = (event, optionValue, inputType, req) => {
    const inputValue = event.target.value;
    let regex = /^\d*$/;
    if (inputType === 4) regex = /.*/;
    if (inputType === 3) regex = /.*/;
    if (regex.test(inputValue)) {
      const updatedPhoneNumbers = phoneNumbers.map((phone) =>
        phone.id === optionValue ? { ...phone, number: inputValue } : phone
      );
      setPhoneNumbers(updatedPhoneNumbers);
      onPhoneNumber(updatedPhoneNumbers);
      localStorage.setItem("phoneNumbers", JSON.stringify(updatedPhoneNumbers));
      setError("");
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].header}
              <span style={{ color: "red" }}>*</span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }} />}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div className="call-list" style={{ position: "relative", zIndex: "9" }}>
            {options.map((option) => (
              <div key={option.id}>
                <button
                  className={`option-button ${
                    communication.contactValues.includes(option.value)
                      ? "selected"
                      : ""
                  }`}
                  onClick={(e) => handleOptionClick(option, e)}
                >
                  <div className="answer-container">
                    <div
                      className="option"
                      style={{
                        backgroundColor: communication.contactValues.includes(
                          option.value
                        )
                          ? "#000"
                          : "#fff",
                        color: communication.contactValues.includes(
                          option.value
                        )
                          ? "#fff"
                          : "#000",
                      }}
                    >
                      {option.id}
                    </div>
                    <div className="option-label" style={{ textAlign: "start" }}>
                      {option.label}
                    </div>
                  </div>
                  {communication.contactValues.includes(option.value) && (
                    <span className="checkmark">&#10003;</span>
                  )}
                </button>
                {communication.contactValues.includes(option.value) &&
                  option.mob_show === 1 && (
                    <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                      <p style={{ fontSize: "18px", marginLeft: "5px", marginRight:"5px" }}>
                        {option.mob_typ === 1 || option.mob_typ === 2
                          ? translations[selectedLang].mobileLabel
                          : option.mob_typ === 3
                          ? translations[selectedLang].linkLabel
                          : translations[selectedLang].urlLabel}{" "}
                        {option.mob_req === 1 && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </p>
                      <textarea
                        type={
                          option.mob_typ === 4
                            ? "url"
                            : option.mob_typ === 3
                            ? "text"
                            : "tel"
                        }
                        value={
                          phoneNumbers.find((phone) => phone.id === option.value)
                            ?.number || ""
                        }
                        inputMode={option.mob_typ <= 2 ? "numeric" : "text"}
                        cols={32}
                        onChange={(e) =>
                          handleInputChange(e, option.value, option.mob_typ, option.mob_req)
                        }
                        placeholder={
                          option.mob_typ === 1 || option.mob_typ === 2
                            ? translations[selectedLang].placeholderMobile
                            : option.mob_typ === 3
                            ? translations[selectedLang].placeholderLink
                            : translations[selectedLang].placeholderUrl
                        }
                      />
                    </div>
                  )}
              </div>
            ))}
          </div>
          <div style={{ position: "relative", zIndex: "9" }}>
            {showOkButton && (
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            )}
          </div>
        </div>
        {error && (
          <div className="error-message" style={{ position: "relative", zIndex: "1000" }}>
            {translations[selectedLang][error]}
          </div>
        )}
        {answer[13] && (
          <p className="alert-box" style={{ position: "relative", zIndex: "1000" }}>
            {translations[selectedLang].alert}
          </p>
        )}
      </div>
    </div>
  );
};

export default SuspectCall;
